// frontend/src/components/EquipoModal.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { equipoService } from '../services/onebaseService';
import usuariosService from '../services/usuariosService';
import './EquipoModal.css';

const EquipoModal = ({ isOpen, onClose, equipo = null, onSave }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    color: '#3b82f6',
    is_active: true,
    miembros_data: []
  });

  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedRol, setSelectedRol] = useState('miembro');

  useEffect(() => {
    if (isOpen) {
      cargarUsuarios();
      if (equipo) {
        setFormData({
          nombre: equipo.nombre || '',
          descripcion: equipo.descripcion || '',
          color: equipo.color || '#3b82f6',
          is_active: equipo.is_active !== undefined ? equipo.is_active : true,
          miembros_data: equipo.miembros ? equipo.miembros.map(m => ({
            usuario: m.usuario,
            usuario_nombre: m.usuario_nombre,
            rol: m.rol
          })) : []
        });
      } else {
        // Reset form for new equipo
        setFormData({
          nombre: '',
          descripcion: '',
          color: '#3b82f6',
          is_active: true,
          miembros_data: []
        });
      }
    }
  }, [isOpen, equipo]);

  const cargarUsuarios = async () => {
    try {
      const response = await usuariosService.getUsuarios();
      const usuariosData = response.usuarios || response.data || [];
      setUsuarios(usuariosData);
    } catch (error) {
      console.error('Error cargando usuarios:', error);
      toast.error('Error al cargar usuarios');
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const agregarMiembro = () => {
    if (!selectedUser) {
      toast.warning('Selecciona un usuario');
      return;
    }

    // Verificar si ya existe
    if (formData.miembros_data.some(m => m.usuario === parseInt(selectedUser))) {
      toast.warning('El usuario ya está en el equipo');
      return;
    }

    const usuario = usuarios.find(u => u.id === parseInt(selectedUser));
    if (!usuario) return;

    setFormData(prev => ({
      ...prev,
      miembros_data: [
        ...prev.miembros_data,
        {
          usuario: usuario.id,
          usuario_nombre: usuario.get_full_name || usuario.username,
          rol: selectedRol
        }
      ]
    }));

    setSelectedUser('');
    setSelectedRol('miembro');
  };

  const removerMiembro = (usuarioId) => {
    setFormData(prev => ({
      ...prev,
      miembros_data: prev.miembros_data.filter(m => m.usuario !== usuarioId)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre.trim()) {
      toast.error('El nombre es requerido');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...formData
      };

      let response;
      if (equipo) {
        response = await equipoService.update(equipo.id, payload);
        toast.success('Equipo actualizado exitosamente');
      } else {
        response = await equipoService.create(payload);
        toast.success('Equipo creado exitosamente');
      }

      if (onSave) {
        onSave(response.data);
      }
      onClose();
    } catch (error) {
      console.error('Error guardando equipo:', error);
      toast.error(error.response?.data?.error || 'Error al guardar equipo');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content equipo-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{equipo ? 'Editar Equipo' : 'Nuevo Equipo'}</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="equipo-form">
          <div className="form-group">
            <label>Nombre del Equipo *</label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              placeholder="Ej: Cuadrilla 1, Equipo Diseño..."
              required
            />
          </div>

          <div className="form-group">
            <label>Descripción</label>
            <textarea
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              rows="3"
              placeholder="Descripción del equipo..."
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Color</label>
              <input
                type="color"
                name="color"
                value={formData.color}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleChange}
                />
                Equipo activo
              </label>
            </div>
          </div>

          <div className="miembros-section">
            <h3>Miembros del Equipo</h3>

            <div className="agregar-miembro">
              <select
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
                className="usuario-select"
              >
                <option value="">Seleccionar usuario...</option>
                {usuarios.map(user => (
                  <option key={user.id} value={user.id}>
                    {user.get_full_name || user.username}
                  </option>
                ))}
              </select>

              <select
                value={selectedRol}
                onChange={(e) => setSelectedRol(e.target.value)}
                className="rol-select"
              >
                <option value="miembro">Miembro</option>
                <option value="lider">Líder</option>
              </select>

              <button
                type="button"
                onClick={agregarMiembro}
                className="btn-agregar"
              >
                + Agregar
              </button>
            </div>

            <div className="miembros-lista">
              {formData.miembros_data.length === 0 ? (
                <p className="no-miembros">No hay miembros en el equipo</p>
              ) : (
                <table className="miembros-table">
                  <thead>
                    <tr>
                      <th>Usuario</th>
                      <th>Rol</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.miembros_data.map(miembro => (
                      <tr key={miembro.usuario}>
                        <td>{miembro.usuario_nombre}</td>
                        <td>
                          <span className={`rol-badge rol-${miembro.rol}`}>
                            {miembro.rol === 'lider' ? 'Líder' : 'Miembro'}
                          </span>
                        </td>
                        <td>
                          <button
                            type="button"
                            onClick={() => removerMiembro(miembro.usuario)}
                            className="btn-remove"
                          >
                            Remover
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" onClick={onClose} className="btn-cancel">
              Cancelar
            </button>
            <button type="submit" disabled={loading} className="btn-save">
              {loading ? 'Guardando...' : (equipo ? 'Actualizar' : 'Crear')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EquipoModal;
